// ComprehensiveSpecialtyCareSection.js
import React from "react";
import { Phone } from "lucide-react";
import comprehensiveSpecialtyCareImage from "../assets/comprehensive-specialty-care-image.jpg";

const ComprehensiveSpecialtyCareSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Comprehensive Specialty Care for Every Stage of Life
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                At Allawah Lodge, our specialty care services are designed to
                support individuals with unique health challenges and ongoing
                medical needs. We understand that every condition requires a
                personalised approach — whether it's recovering after a hospital
                stay, living with a disability, or managing a long-term illness.
                Our caregivers provide focused, in-home assistance that promotes
                independence, comfort, and confidence, giving families peace of
                mind knowing their loved one is receiving attentive,
                professional care.
              </p>

              <p>
                Our specialty care programmes include hospital-to-home
                transition support, disability care, Parkinson's care, and
                chronic condition management. Each service is tailored to the
                individual's medical and emotional needs, ensuring continuity of
                care and improved quality of life. From medication reminders and
                mobility support to companionship and daily living assistance,
                we help make each day safer, more manageable, and more
                fulfilling for our clients.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={comprehensiveSpecialtyCareImage}
              alt="Caregiver with elderly woman outdoors"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComprehensiveSpecialtyCareSection;
